"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Location_utils_1 = require("./Location.utils");
const prop_types_1 = __importDefault(require("prop-types"));
const LocationAddress = ({ street1, street2, suite, city, state, zip }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null,
        react_1.default.createElement(Location_utils_1.Street, { street1: street1, street2: street2, suite: suite })),
    react_1.default.createElement("p", null,
        react_1.default.createElement(Location_utils_1.City, null,
            city,
            Boolean(state || zip) && ', '),
        react_1.default.createElement(Location_utils_1.State, null,
            state,
            " "),
        react_1.default.createElement(Location_utils_1.Zip, null, zip))));
LocationAddress.propTypes = {
    street1: prop_types_1.default.string,
    street2: prop_types_1.default.string,
    suite: prop_types_1.default.string,
    city: prop_types_1.default.string,
    state: prop_types_1.default.string,
    zip: prop_types_1.default.string
};
exports.default = LocationAddress;
//# sourceMappingURL=LocationAddress.js.map